import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import FolderModal from "../../../../common/folder-modal";

export interface IRoleFolderAddProps {
  showModal?: boolean;
  closeModal?: () => void;
  showEditModal?: boolean;
  closeEditModal?: () => void;
  editingFolderId?: string;
  editingFolderName?: string;
  projectId: string;
  componentSetId: string;
  folderParentFolderId?: string | undefined | null;
}

class RoleFolderAddComponent extends PureSdComponent<IRoleFolderAddProps & IWithSDProps, {}> {
  handleAddFolder = (data: { name: string }) => {
    if (!this.props.folderParentFolderId) {
      this.props.sd.addRoleFolder?.(data.name);
    } else {
      this.props.sd.addRoleFolderInFolder?.(this.props.folderParentFolderId, data.name);
    }
    return true;
  };

  handleEditFolder = (data: { name: string }) => {
    if (this.props.editingFolderId) {
      if (!this.props.folderParentFolderId) {
        this.props.sd.editRoleFolder?.(this.props.editingFolderId, data.name);
      } else {
        this.props.sd.editRoleFolderInFolder?.(this.props.folderParentFolderId, this.props.editingFolderId, data.name);
      }
      return true;
    }
    return false;
  };

  onSubmit = async (data: { name: string }): Promise<boolean> => {
    try {
      if (this.props.showEditModal) {
        return this.handleEditFolder(data);
      }
      return this.handleAddFolder(data);
    } catch (e) {
      return false;
    }
  };

  render() {
    return (
      <FolderModal
        showModal={this.props.showModal}
        closeModal={this.props.closeModal}
        showEditModal={this.props.showEditModal}
        closeEditModal={this.props.closeEditModal}
        editingFolderId={this.props.editingFolderId}
        editingFolderName={this.props.editingFolderName}
        onSubmit={this.onSubmit}
        folderType="role"
      />
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const roleFolderAddComponent = withSD<IRoleFolderAddProps>(RoleFolderAddComponent);
export { roleFolderAddComponent as RoleFolderAddComponent };
